<template>
  <v-container fluid>
    <v-card class="pt-10 primary--text" color="transparent" flat>
      <v-row>
        <v-col cols="12">
          <v-row no-gutters justify="center" class="footer text-center">
            <v-col
              cols="12"
              lg="3"
              md="3"
              class="text-left mb-8 mb-lg-0 mb-md-0"
            >
              <div>
                <router-link
                  :to="{ name: 'HomeView' }"
                  class="primary--text text-center text-lg-left text-md-left"
                  style="text-decoration: none"
                >
                  <h2>Cinematic Celebration</h2>
                </router-link>
              </div>
              <div
                class="social-icons text-center text-lg-left text-md-left d-flex align-center mt-4"
                @click="goSocial"
              >
                <strong class="primary--text cursor-pointer"
                  >Follow Us On
                </strong>
                <v-btn icon flat x-samll class="cursor-pointer">
                  <v-icon color="primary">mdi-instagram</v-icon>
                </v-btn>
              </div>
              <div class="text-left">
                <b>Phone No:</b>
                <a
                  class="primary--text"
                  style="text-decoration: none"
                  href="tel:+917411148005"
                >
                  74111-48005
                </a>
              </div>
              <div class="text-left mt-2">
                <b>Mail us: </b>
                <a
                  class="primary--text"
                  style="text-decoration: none"
                  href="mailto:cinematiccelebration@gmail.com"
                >
                  cinematiccelebration@gmail.com
                </a>
              </div>
            </v-col>

            <v-col
              cols="12"
              lg="5"
              md="5"
              sm="6"
              class="text-left mb-8 mb-lg-0 mb-md-0"
            >
              <div class="mb-4 mb-lg-2 mb-md-2 primary--text">
                <b>Quick Links</b>
              </div>
              <v-row>
                <v-col cols="5" lg="5" md="5">
                  <div class="footer-links">
                    <div>
                      <router-link
                        exact
                        :to="{ name: 'HomeView', hash: '#about-us' }"
                        class="primary--text"
                        style="text-decoration: none"
                        >About Us
                      </router-link>
                    </div>
                    <div>
                      <router-link
                        exact
                        :to="{ name: 'HomeView', hash: '#our-space' }"
                        class="primary--text"
                        style="text-decoration: none"
                        >Our Space
                      </router-link>
                    </div>
                    <!-- <div>
                                            <router-link exact :to="{ name: 'HomeView', hash: '#testimonial' }"
                                                class="primary--text" style="text-decoration: none">Testimonial
                                            </router-link>
                                        </div> -->
                    <div>
                      <router-link
                        exact
                        :to="{ name: 'HomeView', hash: '#contact-us' }"
                        class="primary--text"
                        style="text-decoration: none"
                        >Contact us
                      </router-link>
                    </div>
                  </div>
                </v-col>
                <v-col cols="7" lg="5" md="5">
                  <div class="footer-links">
                    <div>
                      <router-link
                        class="primary--text"
                        style="text-decoration: none"
                        :to="{ name: 'TermsAndConditionsView' }"
                      >
                        Terms & Conditions
                      </router-link>
                    </div>
                    <div>
                      <router-link
                        class="primary--text"
                        style="text-decoration: none"
                        :to="{ name: 'RefunfPolicyView' }"
                      >
                        Refund Policy
                      </router-link>
                    </div>
                    <div>
                      <router-link
                        class="primary--text"
                        style="text-decoration: none"
                        :to="{ name: 'PrivacyPolicyView' }"
                      >
                        Privacy Policy
                      </router-link>
                    </div>
                    <!-- <div>
                                            <router-link class="primary--text" style="text-decoration: none"
                                                :to="{ name: 'AdminView' }">
                                                Admin Login</router-link>
                                        </div> -->
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              cols="12"
              lg="4"
              md="4"
              sm="6"
              class="text-left mb-8 mb-lg-0 mb-md-0 primary--text"
            >
              <div class="mb-2">
                <b>Address</b>
              </div>

              <div>Cinematic Celebration</div>

              <div>
                2nd Floor, No.363, Bannerghatta Rd, opp. Reliance Digital, Pai
                Layout, Hulimavu, Bengaluru, Karnataka 560076
              </div>

              <div class="text-left mt-2">
                <b>Managed by: </b>
                K V RAVINDRA BABU
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="pt-0 pt-lg-3 pt-md-3">
                Copyright ©2025 All Rights Reserved | Cinematic Celebration
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "AppFooter",
  components: {},
  methods: {
    goSocial() {
      window.open("https://www.instagram.com/cinematic_celebration.in");
    },
  },
};
</script>
<style scoped>
.footer-links > div {
  margin-bottom: 8px;
}
</style>
